import {register} from '../vendor/theme-scripts/theme-sections';
import videoPlay from '../features/video-play';
import parallaxHero from '../features/parallax-hero';
import productGridReviews from '../features/product-grid';
import {quickAddProduct} from '../features/quick-add';
import {swatchGridSection} from '../features/swatch';

register('image-with-text', [videoPlay, parallaxHero, productGridReviews, quickAddProduct, swatchGridSection]);
